var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_2_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.464150943,0.0164150943 L0.464150943,11.685283 L0.465283018,11.685283 C0.470943396,11.8862264 0.607924529,12.0866038 0.879056604,12.24 L0.879056604,12.24 C1.43264151,12.5530189 2.32981132,12.5530189 2.88283019,12.24 L2.88283019,12.24 C3.1545283,12.0866038 3.29150943,11.8862264 3.29716981,11.685283 L3.29716981,11.685283 L3.29830188,11.685283 L3.29830188,0.0164150943 L0.464150943,0.0164150943 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67622641,0.325471698 L1.27528302,1.11849057 L0.310754717,1.11849057 L0.310754717,1.77679246 C0.310754717,1.84584906 0.357169811,1.91490566 0.45,1.96754718 L0.45,1.96754718 L2.67622641,3.22698113 C2.86245283,3.33283019 3.16415094,3.33283019 3.3509434,3.22698113 L3.3509434,3.22698113 L5.57603774,1.96754718 C5.66886793,1.91490566 5.71584906,1.84584906 5.71584906,1.77622641 L5.71584906,1.77622641 L5.71584906,1.11849057 L4.75075472,1.11849057 L3.3509434,0.325471698 C3.25754717,0.272830189 3.13528302,0.246792453 3.01301887,0.246792453 L3.01301887,0.246792453 C2.89132075,0.246792453 2.7690566,0.272830189 2.67622641,0.325471698",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.115471698,0.206037735 L0.115471698,11.8749057 L0.117169811,11.8749057 C0.122264151,12.0758491 0.259811321,12.2762264 0.530943396,12.4301887 L0.530943396,12.4301887 C1.08396226,12.7426415 1.98169811,12.7426415 2.53471698,12.4301887 L2.53471698,12.4301887 C2.80528302,12.2762264 2.94339623,12.0758491 2.94849057,11.8749057 L2.94849057,11.8749057 L2.95018867,11.8749057 L2.95018867,0.206037735 L0.115471698,0.206037735 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89358491,0.51509434 L1.49320755,1.3081132 L0.528679246,1.3081132 L0.528679246,1.96584906 C0.528679246,2.03547169 0.575094339,2.10452831 0.667924528,2.15716981 L0.667924528,2.15716981 L2.89358491,3.41716981 C3.07981133,3.52245282 3.38207547,3.52245282 3.56830188,3.41716981 L3.56830188,3.41716981 L5.79396226,2.15716981 C5.88679245,2.10452831 5.93264151,2.03547169 5.93264151,1.96584906 L5.93264151,1.96584906 L5.93264151,1.3081132 L4.96811321,1.3081132 L3.56830188,0.51509434 C3.47490566,0.462452831 3.35320754,0.435849057 3.23094339,0.435849057 L3.23094339,0.435849057 C3.10867925,0.435849057 2.9864151,0.462452831 2.89358491,0.51509434",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.371320754,0.146603773 L0.371320754,11.8143396 L0.372452831,11.8143396 C0.378113207,12.015283 0.51509434,12.2162264 0.786226415,12.3696226 L0.786226415,12.3696226 C1.33981132,12.6826415 2.23698113,12.6826415 2.79,12.3696226 L2.79,12.3696226 C3.06113207,12.2162264 3.19867925,12.015283 3.20433962,11.8143396 L3.20433962,11.8143396 L3.20547169,11.8143396 L3.20547169,0.146603773 L0.371320754,0.146603773 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58283018,0.455660378 L1.18245283,1.24811321 L0.217924528,1.24811321 L0.217924528,1.9064151 C0.217924528,1.97490567 0.264339622,2.0445283 0.357169811,2.09716982 L0.357169811,2.09716982 L2.58283018,3.35716982 C2.76849057,3.46245283 3.07132075,3.46245283 3.25754717,3.35716982 L3.25754717,3.35716982 L5.48320755,2.09716982 C5.5754717,2.0445283 5.62245283,1.97490567 5.62245283,1.9064151 L5.62245283,1.9064151 L5.62245283,1.24811321 L4.65735849,1.24811321 L3.25754717,0.455660378 C3.16415094,0.40245283 3.04245283,0.376415095 2.92018868,0.376415095 L2.92018868,0.376415095 C2.79792453,0.376415095 2.67566037,0.40245283 2.58283018,0.455660378",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.439811321,0.0418867925 L0.439811321,11.7096226 L0.440943396,11.7096226 C0.446037736,11.9111321 0.583584906,12.1109434 0.854716981,12.2649057 L0.854716981,12.2649057 C1.40830188,12.5784906 2.30547169,12.5784906 2.85849057,12.2649057 L2.85849057,12.2649057 C3.13018867,12.1109434 3.26716982,11.9111321 3.27283019,11.7096226 L3.27283019,11.7096226 L3.27396226,11.7096226 L3.27396226,0.0418867925 L0.439811321,0.0418867925 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65132075,0.350943396 L1.25150943,1.14283019 L0.286415095,1.14283019 L0.286415095,1.80169811 C0.286415095,1.87075472 0.332830189,1.93981132 0.426226415,1.99301887 L0.426226415,1.99301887 L2.65132075,3.25245282 C2.83754717,3.35830189 3.13981132,3.35830189 3.32603774,3.25245282 L3.32603774,3.25245282 L5.55169811,1.99301887 C5.6445283,1.93981132 5.6909434,1.87075472 5.6909434,1.80169811 L5.6909434,1.80169811 L5.6909434,1.14283019 L4.7264151,1.14283019 L3.32603774,0.350943396 C3.23320755,0.298301887 3.11094339,0.271698114 2.98867924,0.271698114 L2.98867924,0.271698114 C2.86641509,0.271698114 2.74471698,0.298301887 2.65132075,0.350943396",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.13981132,0.186792453 L0.13981132,11.8556604 L0.140943397,11.8556604 C0.146037736,12.0566038 0.283584906,12.2564151 0.555283018,12.4103774 L0.555283018,12.4103774 C1.10830189,12.7228302 2.0054717,12.7228302 2.55849057,12.4103774 L2.55849057,12.4103774 C2.82962264,12.2564151 2.96716981,12.0566038 2.97226416,11.8556604 L2.97226416,11.8556604 L2.97339623,11.8556604 L2.97339623,0.186792453 L0.13981132,0.186792453 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91735849,0.495849056 L1.51754718,1.28886792 L0.552452831,1.28886792 L0.552452831,1.94716981 C0.552452831,2.01622641 0.598301887,2.08528302 0.692264151,2.13735849 L0.692264151,2.13735849 L2.91735849,3.39735849 C3.10415094,3.50264151 3.40528302,3.50264151 3.59207547,3.39735849 L3.59207547,3.39735849 L5.81773585,2.13735849 C5.91113208,2.08528302 5.95754717,2.01622641 5.95754717,1.94716981 L5.95754717,1.94716981 L5.95754717,1.28886792 L4.99245283,1.28886792 L3.59207547,0.495849056 C3.49867925,0.443207547 3.37698113,0.416603773 3.25471698,0.416603773 L3.25471698,0.416603773 C3.13301886,0.416603773 3.01075471,0.443207547 2.91735849,0.495849056",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.520754718,0.178301886 L0.520754718,11.8466038 L0.521320755,11.8466038 C0.526415094,12.0481132 0.663962264,12.2484906 0.935094339,12.4013208 L0.935094339,12.4013208 C1.48924529,12.7149057 2.38584906,12.7149057 2.93886792,12.4013208 L2.93886792,12.4013208 C3.21056604,12.2484906 3.34811321,12.0481132 3.35320754,11.8466038 L3.35320754,11.8466038 L3.35377359,11.8466038 L3.35377359,0.178301886 L0.520754718,0.178301886 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73226415,0.487924528 L1.33188679,1.28037736 L0.366792453,1.28037736 L0.366792453,1.9381132 C0.366792453,2.00716982 0.413207547,2.07622642 0.506603773,2.12943397 L0.506603773,2.12943397 L2.73226415,3.38886792 C2.91792453,3.49471698 3.22018867,3.49471698 3.40641509,3.38886792 L3.40641509,3.38886792 L5.63207547,2.12943397 C5.72490566,2.07622642 5.77188679,2.00716982 5.77188679,1.9381132 L5.77188679,1.9381132 L5.77188679,1.28037736 L4.80679245,1.28037736 L3.40641509,0.487924528 C3.3135849,0.435283019 3.19132075,0.408679245 3.06905661,0.408679245 L3.06905661,0.408679245 C2.94679246,0.408679245 2.82509434,0.435283019 2.73226415,0.487924528",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333962265,0.344716982 L0.333962265,12.0135849 L0.33509434,12.0135849 C0.340754718,12.2145283 0.477735849,12.4149057 0.749433963,12.5683019 L0.749433963,12.5683019 C1.30245283,12.8818868 2.19962264,12.8818868 2.75264151,12.5683019 L2.75264151,12.5683019 C3.02377359,12.4149057 3.16132075,12.2145283 3.1664151,12.0135849 L3.1664151,12.0135849 L3.16754717,12.0135849 L3.16754717,0.344716982 L0.333962265,0.344716982 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5454717,0.0883018868 L1.14566038,0.880754718 L0.180566038,0.880754718 L0.180566038,1.53905661 C0.180566038,1.60811321 0.226981133,1.67716981 0.320377359,1.73037736 L0.320377359,1.73037736 L2.5454717,2.98981133 C2.73226415,3.09566038 3.03339623,3.09566038 3.22018867,2.98981133 L3.22018867,2.98981133 L5.44528302,1.73037736 C5.53924529,1.67716981 5.58566038,1.60811321 5.58566038,1.53905661 L5.58566038,1.53905661 L5.58566038,0.880754718 L4.62,0.880754718 L3.22018867,0.0883018868 C3.12679246,0.0356603774 3.00509434,0.00962264151 2.88283019,0.00962264151 L2.88283019,0.00962264151 C2.76113208,0.00962264151 2.63886792,0.0356603774 2.5454717,0.0883018868",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.464150943,0.174339622 L0.464150943,11.8426415 L0.465283018,11.8426415 C0.470377359,12.0435849 0.607924529,12.2439623 0.879056604,12.3979245 L0.879056604,12.3979245 C1.43264151,12.7103774 2.32981132,12.7103774 2.88283019,12.3979245 L2.88283019,12.3979245 C3.15396226,12.2439623 3.29150943,12.0435849 3.29603774,11.8426415 L3.29603774,11.8426415 L3.29773585,11.8426415 L3.29773585,0.174339622 L0.464150943,0.174339622 Z",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67566037,0.482830188 L1.27528302,1.27584906 L0.31018868,1.27584906 L0.31018868,1.93415094 C0.31018868,2.00320754 0.356603774,2.07226416 0.45,2.12490566 L0.45,2.12490566 L2.67566037,3.38490566 C2.86188679,3.49018867 3.16358491,3.49018867 3.35037736,3.38490566 L3.35037736,3.38490566 L5.5754717,2.12490566 C5.66886793,2.07226416 5.71528302,2.00320754 5.71528302,1.93415094 L5.71528302,1.93415094 L5.71528302,1.27584906 L4.75018867,1.27584906 L3.35037736,0.482830188 C3.25698114,0.430188679 3.13471698,0.404150944 3.01301887,0.404150944 L3.01301887,0.404150944 C2.89075472,0.404150944 2.76849057,0.430188679 2.67566037,0.482830188",
    id: "path-31"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ScnSoft-COM-HomePage-1440_illustrations",
    transform: "translate(-526.000000, -6363.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Industry",
    transform: "translate(135.000000, 6166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(352.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_2_2",
    transform: "translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-165",
    transform: "translate(9.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.622642, 11.815094)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5901698,25.9963584 L70.5997925,25.9963584 L70.5997925,21.1352264 L61.5618679,18.7974905 L41.521868,7.22767924 C38.148849,5.27994339 33.0454529,5.06767924 30.1235661,6.75560377 L9.59733962,18.6056038 L0.0160188679,20.874849 L0.0160188679,25.6737169 C0.0092264151,25.7806981 0.011490566,25.8893774 0.0160188679,25.9963584 L0.0160188679,26.0710754 L0.0194150943,26.0710754 C0.115075472,27.3022075 1.0484717,28.5786226 2.79583019,29.5867359 L29.0843208,44.7650378 C32.4590377,46.7127735 37.561868,46.9250378 40.4837547,45.2382453 L68.6305472,28.9867359 C70.008283,28.1920189 70.6456416,27.1154151 70.5901698,25.9963584",
    id: "Fill-2",
    fill: "#BFC3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6306038,23.8654529 L40.4838113,40.1169623 C37.5619245,41.8031887 32.4590944,41.5909246 29.0843774,39.6437547 L2.7958868,24.4665849 C-0.578830189,22.517717 -0.945056604,19.5720566 1.97683019,17.8846982 L30.1236227,1.63432075 C33.0455094,-0.0530377358 38.1483396,0.158660378 41.5219245,2.10639623 L67.8115472,17.2846981 C71.1862641,19.2318679 71.5524906,22.1792264 68.6306038,23.8654529",
    id: "Fill-4",
    fill: "#E9E8E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8154906,23.3933774 L60.8160567,23.3933774 L60.8160567,22.5426226 L59.2979433,22.6490377 L33.4294528,7.58394339 C32.7003962,7.16281132 31.4268114,7.21601887 30.5851132,7.70167925 L11.4654906,18.6913018 L9.79171698,18.8079057 L9.79171698,19.6411132 C9.79115094,19.6648867 9.7905849,19.6880944 9.79171698,19.7118679 C9.80983018,19.9626227 9.97001887,20.1997925 10.2819057,20.3803584 L37.1777547,36.0380943 C37.9068114,36.4592264 39.1803962,36.4060189 40.0226603,35.9203585 L60.1215283,24.3675283 C60.6037924,24.0890377 60.8386981,23.7296038 60.8154906,23.3933774",
    id: "Fill-6",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8154906,23.3701698 L60.8160567,23.3701698 L60.8160567,22.5194151 L59.2979433,22.6252642 L59.0698302,22.4922453 L57.9785094,22.9320566 L38.3924717,34.8901698 L38.3924717,35.3656416 L38.3924717,36.2935477 C38.9579433,36.2973397 39.5556792,36.1660189 40.0226603,35.897151 L60.1215283,24.3443208 C60.6037924,24.0658302 60.8386981,23.7063963 60.8154906,23.3701698",
    id: "Fill-8",
    fill: "#123155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3755095,21.7361321 L33.4790943,6.07783019 C32.7234339,5.64198114 31.403434,5.69462264 30.5356981,6.19556603 L10.4362642,17.7483963 C9.96249056,18.0217925 9.69079245,18.3919811 9.69079245,18.7627359 C9.69079245,19.0768868 9.88324528,19.3604718 10.2319245,19.5614151 L37.1283396,35.219717 L37.1289056,35.219717 C37.4713584,35.4183962 37.9321132,35.5151886 38.4132453,35.5151886 C38.9906038,35.5151886 39.5985282,35.3753774 40.0717359,35.1019812 L60.1711698,23.5497169 C60.6455095,23.2763207 60.9172075,22.9055661 60.9172075,22.5348114 C60.9172075,22.2212264 60.7241886,21.9370755 60.3755095,21.7361321",
    id: "Fill-10",
    fill: "#CECDCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.961132,15.3610188 L24.961132,14.703283 L23.9960377,14.703283 L22.5956604,13.9102641 C22.4094339,13.8049811 22.1077359,13.8049811 21.9215094,13.9102641 L20.5205661,14.703283 L19.5560378,14.703283 L19.5560378,15.3615849 C19.5560378,15.4306416 19.6024528,15.4996982 19.6952831,15.5523397 L21.9215094,16.8117736 C22.1077359,16.9176226 22.4094339,16.9176226 22.5956604,16.8117736 L24.8213208,15.5523397 C24.914151,15.4996982 24.961132,15.4306416 24.961132,15.3610188",
    id: "Fill-12",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8212642,14.8939811 L22.5956038,16.1545472 C22.4093773,16.2592641 22.1076792,16.2592641 21.9214529,16.1545472 L19.6952264,14.8939811 C19.509,14.7886982 19.509,14.6177547 19.6952264,14.5119056 L21.9214529,13.2524717 C22.1076792,13.1466226 22.4093773,13.1466226 22.5956038,13.2524717 L24.8212642,14.5119056 C25.0074905,14.6177547 25.0074905,14.7886982 24.8212642,14.8939811",
    id: "Fill-14",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.841283,2.84683019 L20.841283,14.5151321 L20.8424151,14.5151321 C20.8480755,14.7166415 20.9850566,14.9164528 21.2561887,15.0704151 C21.8097735,15.3828679 22.7069434,15.3828679 23.2599623,15.0704151 C23.5316604,14.9164528 23.6686415,14.7166415 23.6743019,14.5151321 L23.6754339,14.5151321 L23.6754339,2.84683019 L20.841283,2.84683019 Z",
    id: "Fill-16",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(21.000000, 14.645283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-19-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    points: "2.50918867 1.50967925 2.50918867 12.4223208 2.88050944 12.3119434 3.29824529 11.9683585 3.29824529 0.115528302 2.76050943 0.233264151"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(19.867924, 25.400000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-22-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93869812,2.64950943 L2.93869812,3.30215094 L3.35133962,3.38875471 L5.71567924,1.90177358 L5.7824717,1.09177359 C5.7824717,1.09177359 3.52228302,2.50007547 3.35077358,2.56913208 C3.17813207,2.63762265 2.93869812,2.64950943 2.93869812,2.64950943",
    id: "Fill-22",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-67",
    transform: "translate(23.830188, 16.343397)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0814528,14.1211698 C30.0814528,14.109283 30.0820189,14.0968302 30.0814528,14.0855094 L30.0791886,1.50418868 L0.0774905661,0.534 L0.0814528302,13.1481509 C0.0440943396,13.3994717 0.173716982,13.6445661 0.48164151,13.8228679 L14.8646604,22.0530567 C15.4686226,22.4017358 16.5220188,22.358151 17.2182453,21.9556981 L29.5063584,14.8858867 C29.8856038,14.6668302 30.0791886,14.3509811 30.0814528,14.0855094 L30.0814528,14.1211698 Z",
    id: "Fill-25",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1848113,0.969113208 L15.1848113,22.101 C15.8012265,22.3359057 16.7040566,22.2640188 17.3244339,21.905717 L29.6125471,14.8353396 C29.9917925,14.616283 30.1853773,14.301 30.1876415,14.0349623 L30.1859434,1.45364151 L15.1848113,0.969113208 Z",
    id: "Fill-27",
    fill: "#123155"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#878686",
    points: "7.07677358 17.5726981 11.2354528 19.9738302 11.2354528 10.701566 7.07677358 8.301"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#CECDCC",
    points: "10.7421509 19.1199056 10.7421509 10.9865094 7.57007547 9.15481133 7.56950944 17.2882075"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#2161AC",
    points: "8.01090566 9.94998113 8.01090566 13.1814905 10.2093962 14.447151 10.2093962 11.2156415 9.59977359 10.8680943 8.82090566 10.4175283 8.72184906 10.3609245 8.40769811 10.1775283 8.406 10.1775283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89373585,9.74767924 L7.89373585,9.94975471 L7.89373585,13.2491886 L10.326,14.649 L10.326,11.1486226 L7.89373585,9.74767924 Z M8.01090566,9.94975471 L8.406,10.1778679 L9.59977359,10.8678679 L10.2093962,11.2159811 L10.2093962,14.4474906 L8.01090566,13.1812641 L8.01090566,9.94975471 Z",
    id: "Fill-35",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#2161AC",
    points: "8.01090566 13.779 8.01090566 17.0105094 10.2093962 18.2761698 10.2093962 15.0446604 9.59977359 14.6971133 8.82090566 14.2465472 8.72184906 14.1899433 8.40769811 14.0071132 8.406 14.0071132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89373585,13.5766981 L7.89373585,13.7787736 L7.89373585,17.0782075 L10.326,18.4785849 L10.326,14.9776415 L7.89373585,13.5766981 Z M8.01090566,13.7787736 L8.406,14.0074528 L9.59977359,14.6968867 L10.2093962,15.045 L10.2093962,18.2765094 L8.01090566,17.010283 L8.01090566,13.7787736 Z",
    id: "Fill-39",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#878686",
    points: "7.42058491 12.8885094 7.84567925 13.1341698 7.84567925 14.6879434 7.71832075 14.7615283 7.29322641 12.9620943"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#E4E4E4",
    points: "7.29345282 12.9620377 7.71854718 13.2076981 7.71854718 14.7614718 7.29288679 14.5158114"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#878686",
    points: "2.91826416 15.176434 7.0769434 17.577 7.0769434 8.30530189 2.91826416 5.90473585"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#CECDCC",
    points: "6.58369812 16.7236415 6.58369812 8.59024529 3.41105661 6.75854717 3.41105661 14.8919433"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#2161AC",
    points: "3.85188679 7.55315095 3.85188679 10.7846604 6.05037736 12.0508868 6.05037736 8.81937735 5.44132075 8.47126416 4.66188679 8.02069811 4.56339623 7.96409434 4.24924528 7.78126415 4.24754717 7.78126415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73522641,7.3514151 L3.73522641,7.55292453 L3.73522641,10.8523585 L6.16749057,12.2527358 L6.16749057,8.75235849 L3.73522641,7.3514151 Z M3.85183018,7.55292453 L4.24749056,7.78160377 L5.44126415,8.47160378 L6.05032075,8.81971698 L6.05032075,12.0512264 L3.85183018,10.784434 L3.85183018,7.55292453 Z",
    id: "Fill-51",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#2161AC",
    points: "3.85188679 11.3827358 3.85188679 14.6142453 6.05037736 15.8799056 6.05037736 12.6483962 5.44132075 12.3008491 4.66188679 11.850283 4.56339623 11.7931132 4.24924528 11.610283 4.24754717 11.610283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73522641,11.180434 L3.73522641,11.3825094 L3.73522641,14.6813774 L6.16749057,16.0817547 L6.16749057,12.5813774 L3.73522641,11.180434 Z M3.85183018,11.3825094 L4.24749056,11.6106226 L5.44126415,12.3006226 L6.05032075,12.6487358 L6.05032075,15.8802453 L3.85183018,14.6140188 L3.85183018,11.3825094 Z",
    id: "Fill-55",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#878686",
    points: "6.35150943 12.1765472 6.77660377 12.4222075 6.77660377 13.9759811 6.64924528 14.0495661 6.22415094 12.2501321"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#E4E4E4",
    points: "6.22437736 12.2500755 6.6494717 12.4957358 6.6494717 14.0495094 6.22437736 13.803849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9519623,26.3059245 L18.9519623,25.6476226 L17.986868,25.6476226 L16.5870566,24.8551698 C16.4008302,24.7493208 16.098566,24.7493208 15.9123397,24.8551698 L14.5119623,25.6476226 L13.547434,25.6476226 L13.547434,26.3059245 C13.547434,26.3749811 13.593849,26.4440377 13.6866793,26.4966792 L15.9123397,27.7566792 C16.098566,27.8619623 16.4008302,27.8619623 16.5870566,27.7566792 L18.812717,26.4966792 C18.9055472,26.4440377 18.9519623,26.3749811 18.9519623,26.3059245",
    id: "Fill-61",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8126604,25.8382642 L16.587,27.0988302 C16.4007735,27.2041132 16.0985094,27.2041132 15.912283,27.0988302 L13.6866226,25.8382642 C13.5003963,25.7329812 13.5003963,25.5620377 13.6866226,25.4567547 L15.912283,24.1967547 C16.0985094,24.0909057 16.4007735,24.0909057 16.587,24.1967547 L18.8126604,25.4567547 C18.9988867,25.5620377 18.9988867,25.7329812 18.8126604,25.8382642",
    id: "Fill-63",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8326792,13.7911698 L14.8326792,25.4594717 L14.8338113,25.4594717 C14.8394717,25.6609812 14.9764528,25.8607925 15.2475849,26.0147547 C15.8011698,26.3272076 16.6983396,26.3272076 17.2513585,26.0147547 C17.5224906,25.8607925 17.6600377,25.6609812 17.6656981,25.4594717 L17.6668302,25.4594717 L17.6668302,13.7911698 L14.8326792,13.7911698 Z",
    id: "Fill-65",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-70",
    transform: "translate(38.547170, 29.928302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-68-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-68",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "2.16096227 1.69930189 2.16096227 12.6119434 2.53228302 12.501566 2.95001887 12.1579811 2.95001887 0.305150944 2.41228302 0.422886793"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(36.849056, 40.683019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-71-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15650943,2.83913208 L3.15650943,3.49177359 L3.56915094,3.57837736 L5.93292453,2.09139623 L5.99971698,1.28139623 C5.99971698,1.28139623 3.74009433,2.68969811 3.56858491,2.75875471 C3.3959434,2.82724528 3.15650943,2.83913208 3.15650943,2.83913208",
    id: "Fill-71",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-80",
    transform: "translate(31.754717, 27.098113)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62239622,12.6607358 L5.62239622,12.003 L4.65730188,12.003 L3.25692453,11.2099811 C3.07126416,11.1046981 2.769,11.1046981 2.58277359,11.2099811 L1.18239623,12.003 L0.217867924,12.003 L0.217867924,12.6607358 C0.217867924,12.7297925 0.264283019,12.7988491 0.357113208,12.8520566 L2.58277359,14.1114906 C2.769,14.2173396 3.07126416,14.2173396 3.25692453,14.1114906 L5.48315095,12.8520566 C5.57598113,12.7988491 5.62239622,12.7297925 5.62239622,12.6607358",
    id: "Fill-74",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48309434,12.1936415 L3.25686793,13.4536415 C3.07120755,13.5589245 2.76894339,13.5589245 2.58271698,13.4536415 L0.357056604,12.1936415 C0.170830189,12.0877925 0.170830189,11.9174151 0.357056604,11.811566 L2.58271698,10.5521321 C2.76894339,10.446283 3.07120755,10.446283 3.25686793,10.5521321 L5.48309434,11.811566 C5.66932076,11.9174151 5.66932076,12.0877925 5.48309434,12.1936415",
    id: "Fill-76",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50316982,0.14654717 L1.50316982,11.814283 L1.50430189,11.814283 C1.50996226,12.0157925 1.64694339,12.2161698 1.91807547,12.369566 C2.47166038,12.6825849 3.36883019,12.6825849 3.92184905,12.369566 C4.19298114,12.2161698 4.3305283,12.0157925 4.33618867,11.814283 L4.33732076,11.814283 L4.33732076,0.14654717 L1.50316982,0.14654717 Z",
    id: "Fill-78",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-83",
    transform: "translate(32.886792, 27.098113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-81-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-81",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    points: "2.41635849 1.6395849 2.41635849 12.5522264 2.78767925 12.4418491 3.2054151 12.0982642 3.2054151 0.244867924 2.66767925 0.363169812"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-86",
    transform: "translate(31.754717, 37.852830)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-84-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84581133,2.7794151 L2.84581133,3.43205661 L3.25845283,3.51866038 L5.62222642,2.03111321 L5.68901886,1.22167925 C5.68901886,1.22167925 3.42939623,2.62998113 3.25732076,2.6984717 C3.08524528,2.7675283 2.84581133,2.7794151 2.84581133,2.7794151",
    id: "Fill-84",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-93",
    transform: "translate(14.773585, 17.475472)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6909434,12.5563019 L5.6909434,11.898 L4.7264151,11.898 L3.32603774,11.1055472 C3.13981132,11.0002642 2.83754717,11.0002642 2.65132075,11.1055472 L1.2509434,11.898 L0.286415095,11.898 L0.286415095,12.5563019 C0.286415095,12.6253585 0.332830189,12.6944151 0.425660377,12.7476226 L2.65132075,14.0070567 C2.83754717,14.1129057 3.13981132,14.1129057 3.32603774,14.0070567 L5.55169811,12.7476226 C5.6445283,12.6944151 5.6909434,12.6253585 5.6909434,12.5563019",
    id: "Fill-87",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55164151,12.0892075 L3.32598113,13.3492076 C3.13975472,13.4544906 2.83749057,13.4544906 2.65126415,13.3492076 L0.425603773,12.0892075 C0.239377359,11.9833585 0.239377359,11.8129811 0.425603773,11.7071321 L2.65126415,10.4476981 C2.83749057,10.3418491 3.13975472,10.3418491 3.32598113,10.4476981 L5.55164151,11.7071321 C5.73786792,11.8129811 5.73786792,11.9833585 5.55164151,12.0892075",
    id: "Fill-89",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57171698,0.0415471698 L1.57171698,11.7098491 L1.57284905,11.7098491 C1.57850943,11.9113585 1.71549057,12.1111698 1.98662264,12.2651321 C2.54020755,12.5781509 3.43737735,12.5781509 3.99039623,12.2651321 C4.26209433,12.1111698 4.39907547,11.9113585 4.40473585,11.7098491 L4.40586792,11.7098491 L4.40586792,0.0415471698 L1.57171698,0.0415471698 Z",
    id: "Fill-91",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-96",
    transform: "translate(15.905660, 17.475472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-94-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-14)",
    points: "2.48490566 1.53515094 2.48490566 12.4477924 2.85622641 12.3374151 3.27396226 11.9938302 3.27396226 0.140433962 2.73622641 0.258735849"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-99",
    transform: "translate(14.773585, 28.230189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-97-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91435849,2.67492453 L2.91435849,3.32756604 L3.327,3.41416981 L5.69077358,1.92662265 L5.75813208,1.11718868 C5.75813208,1.11718868 3.49794339,2.52549057 3.32643397,2.59398113 C3.15379246,2.66303773 2.91435849,2.67492453 2.91435849,2.67492453",
    id: "Fill-97",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-106",
    transform: "translate(41.943397, 27.098113)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95737735,12.7016604 L5.95737735,12.0433585 L4.99228302,12.0433585 L3.59190566,11.2509057 C3.40567925,11.1450566 3.10398114,11.1450566 2.91775472,11.2509057 L1.51737736,12.0433585 L0.552283019,12.0433585 L0.552283019,12.7016604 C0.552283019,12.770717 0.598698113,12.8397736 0.692094339,12.8924151 L2.91775472,14.1524151 C3.10398114,14.2576982 3.40567925,14.2576982 3.59190566,14.1524151 L5.81756603,12.8924151 C5.91096226,12.8397736 5.95737735,12.770717 5.95737735,12.7016604",
    id: "Fill-100",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81750943,12.234 L3.59184906,13.4945661 C3.40562264,13.5998491 3.10392453,13.5998491 2.91769811,13.4945661 L0.692037735,12.234 C0.505811321,12.128717 0.505811321,11.9577736 0.692037735,11.8524906 L2.91769811,10.5924906 C3.10392453,10.4866415 3.40562264,10.4866415 3.59184906,10.5924906 L5.81750943,11.8524906 C6.00373585,11.9577736 6.00373585,12.128717 5.81750943,12.234",
    id: "Fill-102",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83815095,0.18690566 L1.83815095,11.8552075 L1.83928302,11.8552075 C1.84437735,12.056717 1.98192453,12.2565283 2.25305661,12.4104906 C2.80664151,12.7229434 3.70381132,12.7229434 4.25683018,12.4104906 C4.52796227,12.2565283 4.66550943,12.056717 4.67060377,11.8552075 L4.67173585,11.8552075 L4.67173585,0.18690566 L1.83815095,0.18690566 Z",
    id: "Fill-104",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-109",
    transform: "translate(43.641509, 27.098113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-107-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-107",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-18)",
    points: "2.18530189 1.68050943 2.18530189 12.5931509 2.55605661 12.4822075 2.97379246 12.1386226 2.97379246 0.285792453 2.43662264 0.403528302"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-112",
    transform: "translate(41.943397, 37.852830)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-110-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18079246,2.81977358 L3.18079246,3.4724151 L3.59343396,3.55901887 L5.95720755,2.07203774 L6.024,1.26260377 C6.024,1.26260377 3.76437736,2.67033963 3.59230189,2.73939623 C3.41966038,2.80788679 3.18079246,2.81977358 3.18079246,2.81977358",
    id: "Fill-110",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-20)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-119",
    transform: "translate(47.037736, 24.267925)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77166037,12.6928302 L5.77166037,12.0350943 L4.80656604,12.0350943 L3.40618868,11.2420755 C3.21996226,11.1367925 2.91826416,11.1367925 2.73203774,11.2420755 L1.33166038,12.0350943 L0.366566037,12.0350943 L0.366566037,12.6928302 C0.366566037,12.7618868 0.412981132,12.8309434 0.506377359,12.884151 L2.73203774,14.1435849 C2.91826416,14.249434 3.21996226,14.249434 3.40618868,14.1435849 L5.63184905,12.884151 C5.72524528,12.8309434 5.77166037,12.7618868 5.77166037,12.6928302",
    id: "Fill-113",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63179245,12.2257358 L3.40613208,13.4857359 C3.21990566,13.5910189 2.91820755,13.5910189 2.73198113,13.4857359 L0.506320754,12.2257358 C0.320094339,12.1198868 0.320094339,11.9495094 0.506320754,11.8436604 L2.73198113,10.5842264 C2.91820755,10.4783774 3.21990566,10.4783774 3.40613208,10.5842264 L5.63179245,11.8436604 C5.81801887,11.9495094 5.81801887,12.1198868 5.63179245,12.2257358",
    id: "Fill-115",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65243397,0.178641509 L1.65243397,11.8463774 L1.65356604,11.8463774 C1.65866037,12.0478868 1.79620754,12.2482641 2.06733963,12.4016604 C2.62092453,12.7146792 3.51752831,12.7146792 4.07054717,12.4016604 C4.34224529,12.2482641 4.47979245,12.0478868 4.48488679,11.8463774 L4.48601887,11.8463774 L4.48601887,0.178641509 L1.65243397,0.178641509 Z",
    id: "Fill-117",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-122",
    transform: "translate(48.169812, 24.267925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-120-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-120",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-22)",
    points: "2.56556604 1.67167925 2.56556604 12.5843208 2.93632075 12.4739434 3.3540566 12.1303585 3.3540566 0.276962264 2.81688679 0.395264151"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-125",
    transform: "translate(47.037736, 35.022641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-123-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99507547,2.81145282 L2.99507547,3.46409434 L3.40771698,3.55069812 L5.77149057,2.06315095 L5.83828302,1.25371698 C5.83828302,1.25371698 3.57866038,2.66201887 3.40658491,2.73050943 C3.2339434,2.79956604 2.99507547,2.81145282 2.99507547,2.81145282",
    id: "Fill-123",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-132",
    transform: "translate(52.132076, 21.437736)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.58537736,12.8597547 L5.58537736,12.2014528 L4.62028302,12.2014528 L3.21990566,11.409 C3.03367924,11.303717 2.73198113,11.303717 2.54575472,11.409 L1.14537736,12.2014528 L0.180283019,12.2014528 L0.180283019,12.8597547 C0.180283019,12.9288113 0.227264151,12.9978679 0.320094339,13.0510755 L2.54575472,14.3105094 C2.73198113,14.4163585 3.03367924,14.4163585 3.21990566,14.3105094 L5.44556604,13.0510755 C5.53896226,12.9978679 5.58537736,12.9288113 5.58537736,12.8597547",
    id: "Fill-126",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44550944,12.3926604 L3.21984905,13.6526603 C3.03362265,13.7579433 2.73192453,13.7579433 2.54569811,13.6526603 L0.320037736,12.3926604 C0.133811321,12.2868113 0.133811321,12.116434 0.320037736,12.0105849 L2.54569811,10.7511509 C2.73192453,10.6453019 3.03362265,10.6453019 3.21984905,10.7511509 L5.44550944,12.0105849 C5.63173584,12.116434 5.63173584,12.2868113 5.44550944,12.3926604",
    id: "Fill-128",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46609434,0.345 L1.46609434,12.0133019 L1.46722641,12.0133019 C1.4728868,12.2148113 1.60986793,12.4146226 1.881,12.5685849 C2.43458491,12.8816038 3.33175472,12.8816038 3.88477359,12.5685849 C4.15590566,12.4146226 4.29345283,12.2148113 4.29854718,12.0133019 L4.29967925,12.0133019 L4.29967925,0.345 L1.46609434,0.345 Z",
    id: "Fill-130",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-135",
    transform: "translate(53.264151, 21.437736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-133-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-133",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-26)",
    points: "2.37928302 1.83860378 2.37928302 12.7512453 2.75003774 12.6408679 3.16777359 12.297283 3.16777359 0.443886792 2.63060378 0.56218868"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-138",
    transform: "translate(52.132076, 32.758490)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-136-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80879245,2.41239623 L2.80879245,3.06503774 L3.22143396,3.15164151 L5.58520754,1.66409434 L5.652,0.854660377 C5.652,0.854660377 3.39237735,2.26296226 3.22030189,2.33145283 C3.04822642,2.40050943 2.80879245,2.41239623 2.80879245,2.41239623",
    id: "Fill-136",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-145",
    transform: "translate(19.867924, 20.305661)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.71528302,12.6889245 L5.71528302,12.0306226 L4.75018867,12.0306226 L3.34981133,11.2381698 C3.16358491,11.1323208 2.86188679,11.1323208 2.67566037,11.2381698 L1.27528302,12.0306226 L0.31018868,12.0306226 L0.31018868,12.6889245 C0.31018868,12.7579811 0.356603774,12.8270377 0.45,12.8796792 L2.67566037,14.1396792 C2.86188679,14.2449623 3.16358491,14.2449623 3.34981133,14.1396792 L5.5754717,12.8796792 C5.66886793,12.8270377 5.71528302,12.7579811 5.71528302,12.6889245",
    id: "Fill-139",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57541509,12.2213208 L3.34975472,13.4818867 C3.1635283,13.5871698 2.86183018,13.5871698 2.67560378,13.4818867 L0.449943396,12.2213208 C0.263716982,12.1160377 0.263716982,11.9450943 0.449943396,11.8398113 L2.67560378,10.5798113 C2.86183018,10.4739623 3.1635283,10.4739623 3.34975472,10.5798113 L5.57541509,11.8398113 C5.76164151,11.9450943 5.76164151,12.1160377 5.57541509,12.2213208",
    id: "Fill-141",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.596,0.174226415 L1.596,11.8425283 L1.59713208,11.8425283 C1.60222641,12.0440377 1.73977358,12.2438491 2.01090567,12.3978113 C2.56449056,12.7102642 3.46166038,12.7102642 4.01467924,12.3978113 C4.28581133,12.2438491 4.42335849,12.0440377 4.42845283,11.8425283 L4.4295849,11.8425283 L4.4295849,0.174226415 L1.596,0.174226415 Z",
    id: "Fill-143",
    fill: "#7C7C7C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-148",
    transform: "translate(21.000000, 20.305661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-146-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-146",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-30)",
    points: "2.50918867 1.66777358 2.50918867 12.5804151 2.87994339 12.4694717 3.29767925 12.1258868 3.29767925 0.273056603 2.76050943 0.390792453"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-151",
    transform: "translate(19.867924, 31.060377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-149-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93869812,2.80703773 L2.93869812,3.45967925 L3.35133962,3.54628302 L5.71511321,2.05930189 L5.78190567,1.24986792 C5.78190567,1.24986792 3.52228302,2.65760378 3.35020755,2.72666038 C3.17756604,2.79515094 2.93869812,2.80703773 2.93869812,2.80703773",
    id: "Fill-149",
    fill: "#123155",
    fillRule: "nonzero",
    mask: "url(#mask-32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-164",
    transform: "translate(13.641510, 0.494339)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-152",
    fill: "#2161AC",
    points: "28.5900566 30.5954151 0.48345283 14.3682453 0.48345283 16.2633397 28.5900566 32.4905094"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-154",
    fill: "#123155",
    points: "46.5435283 20.1718302 28.5899433 30.5954151 28.5899433 32.4905094 46.5435283 22.0669245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-156",
    fill: "#CECDCC",
    points: "46.5435283 20.1718302 28.5899433 30.5954151 0.483339623 14.3682453 18.4369245 3.94466037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-158",
    fill: "#CECDCC",
    points: "32.4920377 0.294169811 14.5390189 10.7188868 0.483735849 11.8260566 18.4361887 1.40133963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-160",
    fill: "#2161AC",
    points: "14.5391887 10.7183208 0.48390566 11.8260566 0.48390566 13.7160566 28.5893774 29.9437925 28.5893774 28.048132"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-162",
    fill: "#123155",
    points: "46.5413207 17.6285094 32.4922641 0.294169811 14.5392453 10.7188868 28.5894339 28.048132 28.59 28.0503962 28.59 29.9454906 46.5435849 19.5224718 46.5435849 17.6268113"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/Financial.5cad13ca36528ac15d01539442732979.svg";
export { ForwardRef as ReactComponent };